export { ArrowsLeftRightIcon } from './arrows-left-right'
